import { z } from "zod";

export const LINEAR_CONVERSATION_MAX_ATTACHMENTS = 10;
export const LINEAR_CONVERSATION_MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const LINEAR_CONVERSATION_MAX_REQUEST_BYTES = 50 * 1024 * 1024;
export const LINEAR_CONVERSATION_MAX_BODY_LENGTH = 10_000;

export const LinearConversationAttachmentFileName = z
  .string()
  .trim()
  .min(1)
  .max(255)
  .regex(/^[^\p{C}]+$/u)
  .refine((value) => !z.string().url().safeParse(value).success, { message: "attachment file name must not be a URL" });
export type LinearConversationAttachmentFileName = z.infer<typeof LinearConversationAttachmentFileName>;

export const LinearConversationInlineMedia = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("image"), url: z.string().startsWith("/") }),
  z.object({ kind: z.literal("video"), url: z.string().startsWith("/") }),
  z.object({ kind: z.literal("none") }),
]);
export type LinearConversationInlineMedia = z.infer<typeof LinearConversationInlineMedia>;

export const LinearConversationAttachment = z.object({
  contentType: z.string().trim().min(1).max(255).optional(),
  downloadUrl: z.string().startsWith("/"),
  fileName: LinearConversationAttachmentFileName,
  id: z.string().trim().min(1),
  inline: LinearConversationInlineMedia,
});
export type LinearConversationAttachment = z.infer<typeof LinearConversationAttachment>;

export const LinearConversationComment = z.object({
  attachments: z.array(LinearConversationAttachment).default([]),
  authorIsViewer: z.boolean(),
  authorName: z.string().trim().min(1),
  body: z.string(),
  createdAt: z.string().datetime({ offset: true }),
  id: z.string().trim().min(1),
});
export type LinearConversationComment = z.infer<typeof LinearConversationComment>;

export const LinearConversationCommentPage = z.object({
  items: z.array(LinearConversationComment),
  nextCursor: z.string().trim().min(1).nullable(),
});
export type LinearConversationCommentPage = z.infer<typeof LinearConversationCommentPage>;

export const PostLinearConversationCommentInput = z
  .object({
    body: z.string().trim().max(LINEAR_CONVERSATION_MAX_BODY_LENGTH).optional(),
    idempotencyKey: z.string().uuid(),
  })
  .strict();
export type PostLinearConversationCommentInput = z.infer<typeof PostLinearConversationCommentInput>;

export const PostLinearConversationCommentResponse = z.object({ commentId: z.string().trim().min(1) });
export type PostLinearConversationCommentResponse = z.infer<typeof PostLinearConversationCommentResponse>;
